module.exports = __webpack_public_path__ + "assets/img/title-57a6a050.png";